import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** PATCH `/srm/purchase-order/{poId}/arrival-schedules/{scheduleId}`。含 updatedAt。 */
export async function updateArrivalSchedule(poId, scheduleId, payload) {
  const { data: raw } = await request.patch(
    `/srm/purchase-order/${poId}/arrival-schedules/${scheduleId}`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
